export default __webpack_public_path__ + "static/media/Snd_CW.6e3538f3.mp3";